import { render, staticRenderFns } from "./LoginSelectModal.vue?vue&type=template&id=c97ba3bc&scoped=true"
import script from "./LoginSelectModal.vue?vue&type=script&lang=js"
export * from "./LoginSelectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97ba3bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c97ba3bc')) {
      api.createRecord('c97ba3bc', component.options)
    } else {
      api.reload('c97ba3bc', component.options)
    }
    module.hot.accept("./LoginSelectModal.vue?vue&type=template&id=c97ba3bc&scoped=true", function () {
      api.rerender('c97ba3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/LoginSelectModal.vue"
export default component.exports